import { __ } from '@wordpress/i18n';
import {
	InspectorControls,
	useBlockEditContext,
} from '@wordpress/block-editor';
import {
	PanelBody,
	PanelRow,
	BaseControl,
	ButtonGroup,
	Button,
	Dashicon,
	TextControl,
	ToggleControl,
	RangeControl,
	TabPanel,
	PanelTabs,
	Icon,
	Placeholder,
} from '@wordpress/components';
import { more } from '@wordpress/icons';
import InspectorIconSelector from '../inspector-components/inspector-icon-selector';
import InspectorImageSelector from '../inspector-components/inspector-image-selector';
import InspectorPresetsSelector from '../inspector-components/inspector-presets-selector';
import InspectorPanelBodyTabs from '../inspector-components/inspector-panel-body-tabs';
import InspectorResponsiveRangeControl from '../inspector-components/inspector-responsive-range-control';
import InspectorColorSelect from '../inspector-components/inspector-color-select';
import InspectorBorderStyle from '../inspector-components/inspector-border-style';
import InspectorBorder from '../inspector-components/inspector-border';
import InspectorFourDimension from '../inspector-components/inspector-four-dimension';
import InspectorTypographyControl from '../inspector-components/inspector-typography-control';
import InspectorSelectRow from '../inspector-components/inspector-select-row';
import InspectorIconImageControl from '../inspector-components/inspector-icon-image-control';
import InspectorSelectButton from '../inspector-components/inspector-select-button';
// import blockJson from '../image/block.json';
import InspectorSelectBlockVariation from '../inspector-components/inspector-select-block-variation';
import InspectorBorderBox from '../inspector-components/inspector-border-box';
import InspectorTypographyControlTab from '../inspector-components/inspector-typography-control-tab';
import InspectorGeneratorAccordion from './InspectorGeneratorAccordion';
import GetFormattedAttrInspector from './GetFormattedAttrInspector';

const InspectorGenerator = ( { props, blockJson } ) => {
	const defaultAttributes = blockJson?.attributes;

	const { name } = useBlockEditContext();
	const { attributes, setAttributes } = props;
	const { initialOpen } = attributes;
	const { tab: openTab, accordionTab: accordionTabOpened } =
		initialOpen || {};
	const accordionTab = { attributes, setAttributes, defaultAttributes };

	const generalTab = GetFormattedAttrInspector(
		defaultAttributes,
		'general'
	);
	const styleTab = GetFormattedAttrInspector( defaultAttributes, 'styles' );

	return (
		<>
			<InspectorControls>
				<div className="alpha-settings">
					<TabPanel
						className=""
						activeClass="active-tab"
						tabs={ [
							{
								name: 'general',
								title: 'General',
								className: 'alpha-tab general',
								icon: (
									<div className="flex flex-col justify-center items-center">
										<Icon icon="admin-generic" />
										General
									</div>
								),
							},
							{
								name: 'styles',
								title: 'Style',
								className: 'alpha-tab styles ',
								icon: (
									<div className="flex flex-col justify-center items-center">
										<Icon icon="admin-appearance" />
										Style
									</div>
								),
							},
							{
								name: 'advance',
								title: 'Advanced',
								className: 'alpha-tab advance ',
								icon: (
									<div className="flex flex-col justify-center items-center">
										<Icon icon="admin-tools" />
										Advance
									</div>
								),
							},
						] }
						onSelect={ ( tabName ) =>
							setAttributes( {
								initialOpen: {
									...( initialOpen || {} ),
									tab: tabName,
								},
							} )
						}
						initialTabName={ openTab }
					>
						{ ( tab ) => (
							<div className="alpha-tab-content">
								{ tab.name === 'general' && (
									<PanelBody
										className="px-0 py-0 alpha-main-tab rounded-none"
										initialOpen={ true }
										onToggle={ ( isOpened ) =>
											console.log(
												'general isOpened:',
												isOpened
											)
										}
									>
										{ Object.keys( generalTab ).map(
											( accordionName, index ) => (
												<InspectorGeneratorAccordion
													{ ...accordionTab }
													AccordionTitle={
														accordionName
													}
													inspectors={
														generalTab[
															accordionName
														]
													}
													key={ index }
												/>
											)
										) }
									</PanelBody>
								) }

								{ tab.name === 'styles' && (
									<PanelBody className="px-0 py-0 alpha-main-tab rounded-none">
										{ Object.keys( styleTab ).map(
											( accordionName, index ) => (
												<InspectorGeneratorAccordion
													{ ...accordionTab }
													AccordionTitle={
														accordionName
													}
													inspectors={
														styleTab[
															accordionName
														]
													}
													key={ index }
												/>
											)
										) }
									</PanelBody>
								) }

								{ tab.name === 'advance' && (
									<PanelBody className="px-0 py-0 alpha-main-tab rounded-none">
										{ /** Start: Advance Tab */ }

										<PanelBody
											title={ __( 'Animation', 'alpha' ) }
											className="!rounded-none !bg-transparent"
											initialOpen={ false }
										>
											<BaseControl>
												<InspectorSelectRow
													options={ [
														{
															label: 'Default',
															value: 'default',
															disabled: true,
														},
													] }
													label={ __(
														'Animation',
														'alpha'
													) }
													value={
														attributes?.animation ??
														'default'
													}
													onChange={ ( val ) =>
														setAttributes( {
															animation: val,
														} )
													}
												/>
											</BaseControl>
										</PanelBody>

										<PanelBody
											title={ __(
												'Display Condition',
												'alpha'
											) }
											className="!rounded-none !bg-transparent"
											initialOpen={ false }
										>
											<BaseControl>
												<InspectorSelectRow
													options={ [
														{
															label: 'Default',
															value: 'default',
														},
													] }
													label={ __(
														'Display Condition',
														'alpha'
													) }
													value={
														attributes?.displayCondition ??
														'default'
													}
													onChange={ ( val ) =>
														setAttributes( {
															displayCondition:
																val,
														} )
													}
												/>
											</BaseControl>
										</PanelBody>

										<PanelBody
											title={ __( 'Z-Index', 'alpha' ) }
											className="!rounded-none !bg-transparent"
											initialOpen={ false }
										>
											<BaseControl>
												<InspectorResponsiveRangeControl
													label={ __(
														'Z-Index',
														'alpha'
													) }
													defaultAttributes={
														defaultAttributes
															?.zIndex?.default
													}
													value={ attributes?.zIndex }
													onChange={ ( val ) =>
														setAttributes( {
															zIndex: val,
														} )
													}
												/>
											</BaseControl>
										</PanelBody>

										<PanelBody
											title={ __(
												'Responsive Condition',
												'alpha'
											) }
											className="!rounded-none !bg-transparent"
											initialOpen={ true }
										>
											<PanelRow>
												<ToggleControl
													className="w-full"
													label={ __(
														'Hide on Desktop',
														'alpha'
													) }
													checked={
														attributes.hideOnDesktop
													}
													onChange={ ( value ) =>
														setAttributes( {
															hideOnDesktop:
																value,
														} )
													}
													__nextHasNoMarginBottom={
														true
													}
												/>
											</PanelRow>
											<PanelRow>
												<ToggleControl
													className="w-full"
													label={ __(
														'Hide on Tablet',
														'alpha'
													) }
													checked={
														attributes.hideOnTablet
													}
													onChange={ ( value ) =>
														setAttributes( {
															hideOnTablet: value,
														} )
													}
													__nextHasNoMarginBottom={
														true
													}
												/>
											</PanelRow>
											<PanelRow>
												<ToggleControl
													className="w-full"
													label={ __(
														'Hide on Mobile',
														'alpha'
													) }
													checked={
														attributes.hideOnMobile
													}
													onChange={ ( value ) =>
														setAttributes( {
															hideOnMobile: value,
														} )
													}
													__nextHasNoMarginBottom={
														true
													}
												/>
											</PanelRow>
										</PanelBody>
										{ /** End: Advance Tab */ }
									</PanelBody>
								) }
							</div>
						) }
					</TabPanel>
				</div>
			</InspectorControls>
		</>
	);
};

export default InspectorGenerator;

window.InspectorGenerator = InspectorGenerator;
